export default __webpack_public_path__ + "static/media/flash16.ea78c2b7.png";